let holidaytypes = ["Planned Leave", "Unplanned Leave", "Sick Leave"];
export default holidaytypes;
